import { createApp } from 'vue'
import App from './App.vue'

// Registrera Service Worker för PWA och offline-stöd
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Kontrollera om det finns en väntande ny version
        reg.onupdatefound = () => {
          const installingWorker = reg.installing
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[Woke News] En ny version av appen är tillgänglig i bakgrunden.')
              }
            }
          }
        }
      })
      .catch((err) => {
        console.warn('[Woke News] Kunde inte registrera Service Worker:', err)
      })
  })
}

createApp(App).mount('#app')
